import { render, staticRenderFns } from "./CourseTeacher.vue?vue&type=template&id=9b68059a&"
import script from "./CourseTeacher.vue?vue&type=script&lang=js&"
export * from "./CourseTeacher.vue?vue&type=script&lang=js&"
import style0 from "./CourseTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports